import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const StyledSection = styled.section`
  position: relative;
  background-color: ${nuDSColor('white', 'dark')};
`;

StyledSection.displayName = 'StyledSection';
